import i18n from '@/locale/index'

export default [
  {
    path: '/myHome',
    name: 'myhomes',
    component: () => import('../../views/myHome/index1.vue'),
    meta: {
      pageKey: 'Myhome_home'
    }
  },
  {
    path: '/newMyHome',
    name: 'newMyHome',
    component: () => import('../../views/myHome/index.vue'),
    meta: {
      title: i18n.global.t('myHome.c53'),
      pageKey: 'Myhome_new'
    }
  },
  {
    path: '/modalBox',
    name: 'modalBox',
    component: () => import('../../views/myHome/getModalBox.vue'),
    meta: {
      title: i18n.global.t('myHome.c48'),
    //   pageKey: 'Myhome_home'
    }
  },
]
